/* @flow */
import React from 'react';
import { Container } from 'flux/utils';
import ConnectedBankAccount from 'entities/ConnectedBankAccount';
import ConnectedBankAccountStore from 'payments/stores/ConnectedBankAccountStore';
import TransactionSettings from 'settings/components/TransactionSettings.jsx';
import CurrentUser from 'auth/CurrentUser';
import apiRequest from 'lib/apiRequest';

type State = {
  canCreateActivity: boolean,
  connectedBankAccounts: ConnectedBankAccount[],
  requestsForUnconfirmedEmail: boolean,
};

class TransactionSettingsContainer extends React.Component {
  state: State;

  static getStores() {
    return [
      CurrentUser,
      ConnectedBankAccountStore,
    ];
  }

  static calculateState(prevState: ?State) {
    return {
      canCreateActivity: CurrentUser.getUser().canCreateActivity(),
      connectedBankAccounts: ConnectedBankAccountStore.getConnectedBankAccounts().models,
      requestsForUnconfirmedEmail: !!prevState && prevState.requestsForUnconfirmedEmail,
    };
  }

  componentDidMount() {
    apiRequest('/payments/connected_bank_accounts/exists', 'GET')
      .then(response => this.setState({ requestsForUnconfirmedEmail: !!response && response.exists }));
  }

  render() {
    return (
      <TransactionSettings
        canCreateActivity={this.state.canCreateActivity}
        connectedBankAccounts={this.state.connectedBankAccounts}
        requestsForUnconfirmedEmail={this.state.requestsForUnconfirmedEmail}
      />
    );
  }
}

export default Container.create(TransactionSettingsContainer);



// WEBPACK FOOTER //
// ./src/settings/containers/TransactionSettingsContainer.jsx